<template>
    <ui-modal name="integration-success">
        <div class="container-modal-integrations-success">
            <div class="container-modal-content">
                <div class="circle-check">
                    <em class="fal fa-check" />
                </div>

                <div class="modal-content-line">
                    <p class="modal-content-line-title">
                        <span class="modal-content-line-title-integration">Disponibilidade {{ typeComputed }} </span>
                        Integrado com sucesso!
                    </p>
                    <p class="modal-content-line-subtitle">O que você deseja fazer agora?</p>
                </div>
            </div>

            <ui-actions-deals-wrapper-list v-model="actions" />

            <ui-button design="primary xxxl mw-150" style="margin-top: 20px" @click="next">
                Avançar
            </ui-button>
        </div>
    </ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiActionsDealsWrapperList } from '@/components/ui-facilita/wrapper'

	import { mapGetters } from 'vuex'

	import { defaultActionList } from '../../data'

	export default {
		name: 'modal-integration-success',

		components: {
			uiModal,
			uiButton,
			uiActionsDealsWrapperList,
		},

		data(){
			return {
				actions:[ ...defaultActionList() ]
			}
		},

		computed: {
			...mapGetters('ERP', {
				integration: 'getSelected',
				integratedAvailability: 'getAvailability'
			}),
			/**
			 * Computed property que retorna a action selecionada
			 */
			activeAction() {
				return this.actions.find(action => action.check)
			},
			/**
			 * Computed property que retorna o tipo da integração que foi cadastrada
			 */
			typeComputed() {
				return this.integration ? this.integration.type : ''
			}
		},

		methods: {
			/**
			 * Executa a ação selecionada
			 */
			next() {
				switch (this.activeAction.action) {
					case 'redirect--show-availability':
						if (!this.integratedAvailability) this.$toastr.e('Nenhuma disponibilidade foi encontrada!')
						var params = { id: this.integratedAvailability.product_id }
						this.$store.dispatch('ERP/removeAvailability')
						this.$router.push({ name: 'products.units', params })
						break

					case 'redirect--new-availability':
						/** Verifica se é uma edição ou cadastro de disponibilidade */
						if (this.$route.params.id) {
							this.$router.push({
								name: 'marketing.integrations.erp.availability',
								params: { id: null }
							})

						} else {
							this.$root.$emit('modal-close-integration-success', this.activeAction.action)
						}
						break

					case 'redirect--integrated-products':
						this.$router.push({ name: 'marketing.integrations.erp.products' })
						break

					case 'redirect--manager-integrations':
						this.$router.push({ name: 'marketing.integrations.erp.integrations' })
						break
				}
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
